import { render, staticRenderFns } from "./exchangeShipment.vue?vue&type=template&id=3b66ff74&scoped=true&"
import script from "./exchangeShipment.vue?vue&type=script&lang=js&"
export * from "./exchangeShipment.vue?vue&type=script&lang=js&"
import style0 from "./exchangeShipment.vue?vue&type=style&index=0&id=3b66ff74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b66ff74",
  null
  
)

export default component.exports